/* eslint-disable no-unreachable -- TODO: remove this when we have a solution for the marker with label */
import React, { useState } from 'react';
import moment from 'moment';
import { Marker, InfoWindow } from 'react-google-maps';

export const getHour = (marker) => {
  const { time_from, time_zone, time_to } = marker;

  const momentFrom = moment(time_from).tz(time_zone);
  const momentTo = moment(time_to).tz(time_zone);

  if (
    momentFrom.isSame(momentTo, 'day') &&
    momentFrom.isSame(momentTo, 'hour') &&
    momentFrom.isSame(momentTo, 'minute')
  ) {
    return { from: momentFrom.format('HH:mm'), to: null };
  }

  return { from: momentFrom.format('HH:mm'), to: momentTo.format('HH:mm') };
};

const StopMarker = ({
  latitude,
  longitude,
  time_from,
  time_to,
  time_zone,
  stop_type,
  company_name,
  isFirst,
  isLast,
  order,
  variant,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { from, to } = getHour({ time_from, time_zone, time_to });

  const isMain = isFirst || isLast;

  const position = {
    lat: latitude,
    lng: longitude,
  };

  // Create custom icon for the marker
  const createCustomIcon = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const size = isMain ? 36 : 24;
    canvas.width = size;
    canvas.height = size;

    // Draw the marker background
    ctx.fillStyle = stop_type === 'DROPOFF' ? '#e53e3e' : '#ffffff';
    ctx.strokeStyle = '#e53e3e';
    ctx.lineWidth = 3;

    if (isMain) {
      // Square for main stops
      ctx.fillRect(0, 0, size, size);
      ctx.strokeRect(0, 0, size, size);
    } else {
      // Circle for regular stops
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2 - 1.5, 0, 2 * Math.PI);
      ctx.fill();
      ctx.stroke();
    }

    // Add text
    ctx.fillStyle = stop_type === 'DROPOFF' ? '#ffffff' : '#000000';
    ctx.font = 'bold 12px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    if (isMain) {
      // Show time for main stops
      const timeText = to ? `${from}-${to}` : from;
      ctx.fillText(timeText, size / 2, size / 2);
    } else {
      // Show order number for regular stops
      ctx.fillText(order.toString(), size / 2, size / 2);
    }

    return {
      url: canvas.toDataURL(),
      scaledSize: new window.google.maps.Size(size, size),
      anchor: new window.google.maps.Point(size / 2, size),
    };
  };

  return (
    <Marker
      position={position}
      zIndex={3}
      icon={createCustomIcon()}
      onClick={() => setIsOpen(!isOpen)}
    >
      {isOpen && (
        <InfoWindow
          onCloseClick={() => setIsOpen(false)}
          options={{
            pixelOffset: new window.google.maps.Size(0, -30),
          }}
        >
          <div style={{ padding: '8px', minWidth: '120px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{company_name}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              {stop_type === 'PICKUP' ? 'Pickup' : 'Dropoff'}
            </div>
            {isMain && (
              <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                {from} {to && `- ${to}`}
              </div>
            )}
            {!isMain && (
              <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>Stop #{order}</div>
            )}
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
};

export default StopMarker;
